import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyBT5OHNGVtzTn5beiPivi4rO0n5PxNEE0I",
  authDomain: "rmrclub-236f4.firebaseapp.com",
  projectId: "rmrclub-236f4",
  storageBucket: "rmrclub-236f4.firebasestorage.app",
  messagingSenderId: "286748362808",
  appId: "1:286748362808:web:6df448015fc9b74f4cfecd",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);

export default app;
